import React from 'react';
import { Header } from '../components/Header';
export const ContactPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 12, maxWidth: 1200, margin: '0 auto' }}>
      <Header />
      <h1>Contact Us</h1>
      <p>If you have any questions, feedback, or support requests, please contact us:</p>

      <p>
        Email: <a href="mailto:davidrensh@hotmail.com">davidrensh@hotmail.com</a>
      </p>

      <p>
        Website: <a href="https://nhenews.com">https://nhenews.com</a>
      </p>

      <p>
        We will try to respond as soon as possible.
      </p>
    </div>
  );
};
